/**
 * Known client-side environment variables.
 */
export interface Env {
  ADMIN_API: string
  AUTH0_AUDIENCE_URL: string
  AUTH0_CLIENT_ID: string
  AUTH0_DOMAIN: string
  BILLING_API: string
  DOCUMENT_API: string
  DOCUMENT_API_EXTERNAL: string
  FRESHBOOKS_API: string
  FRESHBOOKS_API_EXTERNAL: string
  HMR_SOCKET_PORT: string
  HQ_URL: string
  IAM_API: string
  IAM_API_EXTERNAL: string
  JOB_API: string
  JOB_API_EXTERNAL: string
  LAUNCHDARKLY_CLIENT_SIDE_ID: string
  LEGEND_API: string
  LOGROCKET_KEY: string
  MESSAGE_API: string
  NOTIFICATION_API: string
  ORIGIN_WORTAL: string
  PROVIDER_PORTAL_URL: string
  IMPERSONATED_PROVIDER_PORTAL_URL: string
  CLIENT_PORTAL_URL: string
  STRIPE_PK: string
  STRIPE_CONNECT_ID: string
  WORK_DOTNET_API: string
  WUNDER_API: string
  WUNDER_API_EXTERNAL: string
  WUNDER_API_INTERNAL: string

  // BigMoney is optional.
  BIGMONEY_API?: string

  // Realtime events from Wunder API are optional.
  WUNDER_API_EVENTS?: boolean

  TXF_PORTAL_URL: string
}

/**
 * The environment variables for the client.
 */
export const Env = window.__env as Env
